import { render, staticRenderFns } from "./communicationDashboardParty.vue?vue&type=template&id=a39da26c&scoped=true"
import script from "./communicationDashboardParty.vue?vue&type=script&lang=js"
export * from "./communicationDashboardParty.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardParty.vue?vue&type=style&index=0&id=a39da26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39da26c",
  null
  
)

export default component.exports